define([
	"dojo/_base/declare",
	"dijit/form/_TextBoxMixin",
	"csi/html",
	"./FilteringSelect"
], function (declare, _TextBoxMixin, html, FilteringSelect) {

	return declare(FilteringSelect, {

		focus: function () {

			// summary: highlight text and start search when widget comes into focus if so configured
			this.inherited(arguments);

			if (!this._opened) {
				_TextBoxMixin.selectInputText(this.focusNode);
			}
		},

		onSelectOption: function () {
			// summary: extension point for selecting an option which does not necessarily mean a change in value;
			// this is more appropriate for inline editing than using just onChange
		},

		_selectOption: function (/*DOMNode*/target) {
			// summary: call extension point when new option is selected - either by mouse click or Enter key
			this.inherited(arguments);

			if (target) {
				if (this.hasActionsWithoutAutocomplete()) {
					//check if autoComplete is off and store action data exists, if exists call announce option to set item
					this._announceOption(target)
				}

				// mark the New Action is being clicked 
				if (target.classList.contains(html.CSS_DROPDOWN_ACTION)) {
					this.bClickNewAction = true;
				}

				this.onSelectOption();
			}
		},

		_setValueAttr: function (/*String*/ value, /*Boolean?*/ priorityChange, /*String?*/ displayedValue, /*item?*/ item) {
			// summary: DOJO INTERNAL: FilteringSelect has special code to manage empty value (""). We need to override that
			// so it finds an item for the empty value and does not treat it as an invalid value (assuming it is in the store).
			// This is currently only necessary for String Selection.
			var s = this.store;

			if (s && (s.idProperty == s.labelProperty) && !item && (value === "") && (displayedValue == null)) {
				displayedValue = "";
			}

			this.inherited(arguments, [value, priorityChange, displayedValue, item]);
		}
	});
});